{
  "details": {
    "label": "Class Details",
    "curriculum": "Curriculum:",
    "subject_name": "Subject Name:",
    "timezone_id": "Teaching Timezone:",
    "class_size": "{{min}} - {{max}} students",
    "class_size.label": "Class Size:",
    "cycle_length_one": "{{count}} week",
    "cycle_length_other": "{{count}} weeks",
    "cycle_length.label": "Cycle Length:",

    "live_sessions.label": "Live Sessions:",
    "live_sessions.none": "No Live Sessions",
    "live_sessions_one": "{{count}} Live Session of {{duration}} minutes",
    "live_sessions_other": "{{count}} Live Sessions of {{duration}} minutes",

    "other_sessions.label": "Other Sessions:",
    "other_sessions.none": "No Other Sessions",
    "other_sessions_one": "{{count}} Other Session of {{duration}} minutes",
    "other_sessions_other": "{{count}} Other Sessions of {{duration}} minutes",

    "student_led_sessions.label": "Student Led Sessions:",
    "student_led_sessions.none": "No Student Led Sessions",
    "student_led_sessions_one": "{{count}} Student Led Session of {{duration}} minutes",
    "student_led_sessions_other": "{{count}} Student Led Sessions of {{duration}} minutes",

    "num_classes.label": "Number of Classes Offered:",
    "num_classes_one": "{{count}} class offered",
    "num_classes_other": "{{count}} classes offered"
  },
  "actions.back": "Back to search",
  "video.trigger.label": "Watch Video",
  "listing_details": {
    "label": "The Listing",
    "webpage_link": "View Webpage",
    "written_comment.label": "Written Comment",
    "personal": "Personal Listing",
    "team": "Team Listing",
    "shortlist": "Shortlist Team",
    "shortlist_team": "Shortlist {{teamName}}",
    "shortlisted_one": "Shortlisted",
    "shortlisted_other": "In {{count}} shortlists"
  },
  "teaching_details": {
    "label": "Who's Teaching?",
    "shortlist": "Shortlist Teacher",
    "shortlist_teacher": "Shortlist {{teacherName}}",
    "experience.label": "View Experience",
    "experience.education_qualifications": "Education Qualifications:",
    "experience.teaching_experiences": "Teaching Experience:",
    "experience.title": "Experience",
    "shortlisted_one": "Shortlisted",
    "shortlisted_other": "In {{count}} shortlists"
  },
  "timetable": {
    "label": "Session Times",
    "events.short_title": "P{{priority}} {{teacherInitials}}",
    "events.short_title_without_initials": "P{{priority}}",
    "schedule": {
      "duration": "{{duration}} minutes",
      "fixed": "Day {{day}} {{start}} - {{end}}",
      "fixed_timezone": "(Day {{day}} {{start}} - {{end}} {{timezone}})",
      "priority": "Priority {{priority}}"
    },
    "teacher_selector.placeholder": "Search teachers",
    "teacher_selector.label": "Teachers",
    "list": {
      "label": "Selected Teachers",
      "select_all_teachers": "Select All Teachers",
      "clear_all": "Clear All"
    }
  },
  "speciality": {
    "label": "Specialities"
  },
  "live_classes": {
    "label": "Live Classes",
    "title": "{{class_name}} (Priority {{priority}} #{{instance}})",
    "student_count": "Student Count",
    "available_space": "Available Space",
    "timetable_sessions": "Timetable Sessions",
    "request_to_join": "Request to Join"
  },
  "attributes": {
    "teach_attributes_exclusively.label": "Teach Attributes Exclusively",
    "description.label": "Description",
    "speciality_religions.label": "Religions",
    "speciality_genders.label": "Genders",
    "speciality_primary_languages.label": "Primary Languages",
    "speciality_secondary_languages.label": "Secondary Languages",
    "overall_qualitative_assessment.label": "Overall Qualitative Assessment",
    "subject_grade_range.label": "Subject Grade Range",
    "naplan_score.label": "NAPLAN Score (Year 9)",
    "wisc_v.label": "WISC V",
    "wiat_iv.label": "WIAT IV",
    "wais_iv.label": "WAIS IV",
    "aeas.label": "AEAS",
    "parent_socio_economic.label": "Parent Socioeconomic Details",
    "learning_styles.label": "Learning Styles",
    "learning_style_description.label": "Description",
    "learning_style_vark.label": "VARK",
    "learning_style_gardner.label": "Gardner's Multiple Intelligences",
    "learning_style_kolb.label": "Kolb's Experiential Learning Theory",
    "learning_preference.label": "Students Learning Preferences",
    "eyesight.label": "Eyesight",
    "adhd.label": "ADHD",
    "autism.label": "Autism",
    "depression.label": "Depression",
    "student_socio_economic.label": "Student Socio Economic details"
  },
  "actions": {
    "shortlist_class": "Shortlist Class"
  }
}
